import { render } from "./App.vue?vue&type=template&id=815ebd6a"
const script = {}

import "./App.vue?vue&type=style&index=0&id=815ebd6a&lang=css"
script.render = render

export default script